export enum LicenseName {
  Basic = 'Basic',
  Genius = 'Genius',
  Magic = 'Magic',
  Default = 'Default',
}

export enum LicenseLabeling {
  CE = 'ce',
  LEGACY = 'legacy',
  RUO = 'ruo',
}

export interface FeatureConfig {
  enabled: boolean;
}

export type Feature<T extends FeatureConfig> = boolean | T;

export interface AnalysisReviewFeatureConfig extends FeatureConfig {
  manager_review?: boolean;
}

export interface ILicenseFeatures {
  ai?: Feature<FeatureConfig>;
  second_opinion?: Feature<FeatureConfig>;
  export_workspace?: Feature<FeatureConfig>;
  analysis_review?: Feature<AnalysisReviewFeatureConfig>;
  download_available?: Feature<FeatureConfig>;
}

export interface ILicenseInfo {
  maxStorage: number;
  maxWorkspaces: number;
  maxUsers: number;
  features: ILicenseFeatures;
  labeling?: LicenseLabeling[];
  tiraspot?: boolean;
  language?: string;
}

export interface LicenseAttributes {
  name: LicenseName;
  info: ILicenseInfo;
}

export class License {
  constructor(private readonly attributes: LicenseAttributes) {}

  public get name(): LicenseName {
    return this.attributes.name;
  }

  public get info(): ILicenseInfo {
    return this.attributes.info;
  }
}
